/**
 * Application configuration for Share IT platform integration
 */
export interface AppConfig {
  platformUrl?: string;
  platformApiKey?: string;
  cmsUrl?: string;
  cmsApiKey?: string;
  cmsInstanceId?: string;
  mediaUrl?: string;
  appName?: string;
  appUrl?: string;
  /** Public host for shared links (Universal/App Links, store landing). Falls back to appUrl. */
  shareUrl?: string;
  appId?: string;
  entraClientId?: string;
  entraTenantSubdomain?: string;
  entraTenantId?: string;
  talkdeskTouchpointId?: string;
  talkdeskTouchpointIdNonMember?: string;
  googleMapsApiKey?: string;
  sfmcMid?: string;
  sfmcAppIdIos?: string;
  sfmcAccessTokenIos?: string;
  sfmcServerUrlIos?: string;
  sfmcAppIdAndroid?: string;
  sfmcAccessTokenAndroid?: string;
  sfmcServerUrlAndroid?: string;
}

export const getConfig = (): AppConfig => {
  const cmsApiKey = import.meta.env.VITE_CMS_API_KEY;
  const platformApiKey = import.meta.env.VITE_PLATFORM_API_KEY;
  const platformUrl = import.meta.env.VITE_PLATFORM_URL;
  const cmsUrl = import.meta.env.VITE_CMS_URL;
  const cmsInstanceId = import.meta.env.VITE_CMS_INSTANCE_ID;
  const mediaUrl = import.meta.env.VITE_MEDIA_URL;
  const appName = import.meta.env.VITE_APP_NAME;
  const appUrl = import.meta.env.VITE_APP_URL;
  const shareUrl = import.meta.env.VITE_SHARE_URL;
  const appId = import.meta.env.VITE_APP_ID;
  const entraClientId = import.meta.env.VITE_ENTRA_CLIENT_ID;
  const entraTenantSubdomain = import.meta.env.VITE_ENTRA_TENANT_SUBDOMAIN;
  const entraTenantId = import.meta.env.VITE_ENTRA_TENANT_ID;
  const talkdeskTouchpointId = import.meta.env.VITE_TALKDESK_TOUCHPOINT_ID;
  const talkdeskTouchpointIdNonMember = import.meta.env.VITE_TALKDESK_TOUCHPOINT_ID_NON_MEMBER;
  const googleMapsApiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
  const sfmcMid = import.meta.env.VITE_SFMC_MID;
  const sfmcAppIdIos = import.meta.env.VITE_SFMC_APP_ID_IOS;
  const sfmcAccessTokenIos = import.meta.env.VITE_SFMC_ACCESS_TOKEN_IOS;
  const sfmcServerUrlIos = import.meta.env.VITE_SFMC_SERVER_URL_IOS;
  const sfmcAppIdAndroid = import.meta.env.VITE_SFMC_APP_ID_ANDROID;
  const sfmcAccessTokenAndroid = import.meta.env.VITE_SFMC_ACCESS_TOKEN_ANDROID;
  const sfmcServerUrlAndroid = import.meta.env.VITE_SFMC_SERVER_URL_ANDROID;
  // Debug logging (only in browser/client-side to avoid server logs)
  if (typeof window !== 'undefined' && !cmsApiKey) {
    console.warn('[getConfig] CMS API key not found!');
    console.warn('[getConfig] VITE_CMS_API_KEY:', import.meta.env.VITE_CMS_API_KEY ? 'SET' : 'NOT SET');
  }
  if (typeof window !== 'undefined' && !platformApiKey) {
    console.warn('[getConfig] Platform API key not found!');
    console.warn(
      '[getConfig] VITE_PLATFORM_API_KEY:',
      import.meta.env.VITE_PLATFORM_API_KEY ? 'SET' : 'NOT SET'
    );
  }

  return {
    platformUrl,
    platformApiKey,
    cmsUrl,
    cmsApiKey,
    cmsInstanceId,
    mediaUrl,
    appName,
    appUrl,
    shareUrl,
    appId,
    entraClientId,
    entraTenantSubdomain,
    entraTenantId,
    talkdeskTouchpointId,
    talkdeskTouchpointIdNonMember,
    googleMapsApiKey,
    sfmcMid,
    sfmcAppIdIos,
    sfmcAccessTokenIos,
    sfmcServerUrlIos,
    sfmcAppIdAndroid,
    sfmcAccessTokenAndroid,
    sfmcServerUrlAndroid,
  };
};

export const config = { getConfig };
